const data = {
  cv: '',
  behance: 'https://www.behance.net/mandxalinka',
  linkedin: 'https://www.linkedin.com/in/alina-ermolaeva-/',
  telegram: '',
  mainTags: [
    'JTBD',
    'User & Market Research',
    'Usability testing',
    'Accessibility',
    'CJM',
    'Qualitative research',
    'UX design',
    'Wireframing',
    'UX research',
    'Quantitative research',
    'Design systems',
    'Problem solving',
    'User centred design',
    'User-Centered Design',
    'Prototyping',
    'Interaction design'
  ],
  cases: [
    {
      title: 'DocsDNA | AI-powered document review',
      description: 'DocsDNA helps people review documents like contracts and agreements, making tasks easier and extracting information quickly and cost-effectively using AI.',
      imageName: 'case-3.png',
      link: 'https://www.figma.com/proto/4d5IYD5jVNmOqNwZLiYwWC/Alina-Ermolaeva-Portfolio?page-id=3164%3A2340&node-id=3164-2577&node-type=frame&viewport=939%2C46%2C0.03&t=v77Ct7hCguA72fTp-1&scaling=contain&content-scaling=fixed',
      tags: [
        'Design system',
        'UI design',
        'B2B',
        'B2C',
        'UX research',
        'Usability testing',
        '2023-2024'
      ]
    },
    {
      title: 'rTIM | AI Application for architects and urbanists',
      description: 'rTIM is an application that empowers architects, urban planners and developers to plan and design areas for districts and cities using AI',
      imageName: 'case-1.png',
      link: 'https://www.figma.com/proto/4d5IYD5jVNmOqNwZLiYwWC/Alina-Ermolaeva-Portfolio?page-id=1489%3A11747&node-id=1489-20564&viewport=2%2C76%2C0.02&t=YttaTJyBqKK9uRtO-1&scaling=contain',
      tags: [
        'Design system',
        'UI design',
        'B2B',
        'Qualitative research',
        'Usability testing',
        '2023'
      ]
    },
    {
      title: 'DocsDNA website',
      description: 'Website for AI Powered Document Analysis app',
      imageName: 'case-4.png',
      link: 'https://www.behance.net/gallery/210120265/DocsDNA-AI-Powered-Document-Analysis-Website',
      tags: [
        'Web design',
        'UI design',
        '2024'
      ]
    },
    {
      title: 'Life in science | Educational platform',
      description: 'Life in Science is an educational platform for ITMO University students studying soft skills. It was created as an alternative to offline courses for students who cannot attend in-person classes.',
      imageName: 'case-2.png',
      link: 'https://www.figma.com/proto/4d5IYD5jVNmOqNwZLiYwWC/Alina-Ermolaeva-Portfolio?page-id=1647%3A13692&node-id=1647-13780&viewport=696%2C31%2C0.03&t=ah7Egu2D5auqomlQ-1&scaling=contain',
      tags: [
        'Design system',
        'UI design',
        'B2C',
        'Qualitative research',
        'Usability testing',
        'Mentoring',
        '2022'
      ]
    }
  ]
}
export default data
